var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.iconcolor,"size":_vm.size}},[_c('span',{staticClass:"text-h6",staticStyle:{"color":"#5a5757"}},[_vm._v(_vm._s(_vm.avataricon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }